import { Kundendivision, usePartner, usePartnerWechselnMutation } from '@tbitop/oneplatform-api';
import { Select } from '@tbitop/ui';

export const PartnerSelect = () => {
  const { partners, currentPartner } = usePartner();
  const { execute: partnerWechseln } = usePartnerWechselnMutation();

  const options = partners?.map(partner => {
    const name = partner.anzeigename;
    const ids = [...partner.fachlicheIds].filter(id => id.name === 'SAP-Nr');
    ids.sort((a, b) => {
      if (a.kundendivision === Kundendivision.Solution) return -1;
      if (b.kundendivision === Kundendivision.Solution) return 1;
      if (a.kundendivision === Kundendivision.Grosshandel) return -1;
      if (b.kundendivision === Kundendivision.Grosshandel) return 1;
      if (a.kundendivision === Kundendivision.Einzelhandel) return -1;
      if (b.kundendivision === Kundendivision.Einzelhandel) return 1;
      return 0;
    });
    const idsString = ids.map(id => id.wert).join(', ');

    return { label: ids.length > 0 ? `${name} (${idsString})` : name, value: partner.id };
  });

  return <div className="[&_.tds-option-container]:max-w-[200px]">
    <label>
      <span className="tds-input-label ">Partnerauswahl:</span>
      <Select
        addEmptyOption={false}
        displayOptionsFilter={(partners?.length || 0) > 10}
        className="w-full"
        variant="small"
        onValueChange={async id => {
          await partnerWechseln({ mandantenId: id });
          window.location.reload();
        }}
        options={options || []}
        value={currentPartner}
      />
    </label>
  </div>;
};
